export default __webpack_public_path__ + "static/halcyon-medium-edb2a40911c893fbc3b601d04ca31120.ttf";